import columns from './utils/columns'
import messages from './utils/messages'

const { statusCodes } = messages

const state = {
  columns,
  didLoadViewFail: false,
  isLoadingView: false,
  network: null,
  routeNames: ['admanager', 'creatives', 'lineitems', 'networks', 'orders'],
  statusCodes,
  testNetworkId: '249793494',
  viewStatus: 200,
}

export default state
